export default __webpack_public_path__ + "static/440-4bcc6034d8956cc1e5a8f8ec6064ea72.gif";